module.exports = __webpack_public_path__ + "assets/img/season4-36f8bf1d.png";